import { render, staticRenderFns } from "./DepartmentEditDialog.vue?vue&type=template&id=5895c680"
import script from "./DepartmentEditDialog.vue?vue&type=script&lang=js"
export * from "./DepartmentEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports